import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import { getUsers } from "../../store/admin/actions"
import { getDataEntryPlants } from "../../store/hackathon/actions"

import { connect } from 'react-redux'
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  CardSubtitle,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

const Leaderboard = props => {
   const { dataentryplants, leaders, onGetUsers, onGetDataEntryPlants } = props

  useEffect (() => {
        onGetDataEntryPlants()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}

             <Card outline className="border">
                <CardHeader  style={{backgroundColor:'#AEBFFF'}}>
                  <h5>
                     SAGE Hackathon Leaderboard
                  </h5>
                </CardHeader>
                <CardBody>
	      <Row style={{marginBottom: "5px"}}>
              <Col md={4}><b>SAGE Hackathon Participant</b></Col>
              <Col md={4}><b>Level</b></Col>
	      <Col md={4}><b>Points</b></Col>
         </Row>
	  
	   {Object.keys(leaders).map ( (leader)=> (
                   <Row style={{marginBottom: "5px"}}>
              <Col md={4}>{leader}</Col>
              <Col md={4}>{leaders[leader]>=10 && <span>Master</span>}{leaders[leader]>=5 && leaders[leader]<10 && <span>Journeyman</span>}{leaders[leader]<5 && <span>Apprentice</span>}</Col>
              <Col md={4}>{leaders[leader]*5}</Col>
               </Row>
	   ))}

	       </CardBody>
	    </Card>

        </Container>
      </div>
    </React.Fragment>
  )
}

Leaderboard.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  var userboard = {}
  if (state.hackathon.plants) {
      for (var plant in state.hackathon.plants) {
	   var username = state.hackathon.plants[plant].username
	   if (!userboard[username]) {
	      userboard[username] = 1;
	   } else {
	      userboard[username] ++;
	   } 
      }
  }
 return({
    leaders: userboard,
    dataentryplants: state.hackathon.plants
  })
}

const mapDispatchToProps = dispatch => ({
  onGetUsers: () => dispatch(getUsers()),
  onAddDataEntryPlant: (plant) => dispatch(addDataEntryPlant(plant)),
  onGetDataEntryPlants: () => dispatch(getDataEntryPlants()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Leaderboard)
